<template>
  <MusicCollectionCard v-if="this.globalResources.portalType === this.portalType.Music" :item="item" />
  <GameCollectionCard v-else-if="this.globalResources.portalType === this.portalType.Game" :item="item" />
</template>

<script>
import enums from '@/utilities/enums.js'
import GameCollectionCard from '@/components/GameCollectionCard.vue'
import MusicCollectionCard from '@/components/MusicCollectionCard.vue'

export default {
  name: 'CollectionCard',
  components: {
    GameCollectionCard,
    MusicCollectionCard
  },
  mixins: [enums],
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
